import Service from '../Service'

export default class RegiaoService extends Service{

    constructor(){
        super('regiao');
    }
  
  }